import React from 'react';
import { Button } from './ui/button';
import { heroData } from '../eiraa_mock';
import { ArrowRight, Phone } from 'lucide-react';

const EiraaHero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="EIRAA Sauna"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/80"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 text-center">
        <div className="max-w-4xl mx-auto">
          <img 
            src="https://customer-assets.emergentagent.com/job_62116a6f-10ce-41f6-9d09-087f8531a25f/artifacts/pi6mf5vx_logo.png" 
            alt="FASTFIX Logo" 
            className="h-40 md:h-56 lg:h-72 w-auto mx-auto mb-8 drop-shadow-2xl"
            style={{ filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.3))' }}
          />
          
          <p className="text-2xl md:text-3xl text-amber-100 mb-4 font-light italic">
            {heroData.subtitle}
          </p>
          
          <p className="text-lg md:text-xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto">
            {heroData.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => scrollToSection('products')}
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white text-lg px-10 py-7 group transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/30"
            >
              {heroData.ctaPrimary}
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button
              onClick={() => scrollToSection('contact')}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 text-lg px-10 py-7 transition-all duration-300 backdrop-blur-sm"
            >
              <Phone className="mr-2" size={20} />
              {heroData.ctaSecondary}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default EiraaHero;